//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Guids for EntityTypes */
export const EntityType = {
    /** The EntityType Guid for Rock.Achievement.Component.AccumulativeAchievement  */
    AccumulativeAchievementComponent: "05D8CD17-E07D-4927-B9C4-5018F7C4B715",
    /** The achievement attempt */
    AchievementAttempt: "5C144B51-3D2E-4BC2-B6C7-7E4CB890E15F",
    /** The achievement type */
    AchievementType: "0E99356C-0DEA-4F24-944E-21CD5FA83B9E",
    /** The achievement type prerequisite */
    AchievementTypePrerequisite: "5362DB19-B8E1-4378-A66A-FB097CE3AB90",
    /** The EntityType Guid for Rock.Model.AnalyticsDimCampus  */
    AnalyticsDimCampus: "DCEB0575-1351-4CFF-BA4F-410BA2D638CB",
    /** The EntityType Guid for Rock.Model.AnalyticsDimFamilyCurrent  */
    AnalyticsDimFamilyCurrent: "B78878C9-4EB7-4EE4-BB85-D00CCA83BCEA",
    /** The EntityType Guid for Rock.Model.AnalyticsDimFamilyHeadOfHousehold  */
    AnalyticsDimFamilyHeadOfHousehold: "89730008-FD3F-49BE-9084-6CC5EA4DC4B3",
    /** The EntityType Guid for Rock.Model.AnalyticsDimFamilyHistorical  */
    AnalyticsDimFamilyHistorical: "D906B981-9603-4B5F-9009-31F6EDDE9DC3",
    /** The EntityType Guid for Rock.Model.AnalyticsDimFinancialAccount  */
    AnalyticsDimFinancialAccount: "893F38F8-FBF8-4157-B718-6009298ABC91",
    /** The EntityType Guid for Rock.Model.AnalyticsDimFinancialBatch  */
    AnalyticsDimFinancialBatch: "F970FF85-F3ED-41BD-90D9-5511BACED928",
    /** The EntityType Guid for Rock.Model.AnalyticsDimPersonCurrent  */
    AnalyticsDimPersonCurrent: "30CBF82B-4C90-4767-9C2D-622308439BF2",
    /** The EntityType Guid for Rock.Model.AnalyticsDimPersonHistorical  */
    AnalyticsDimPersonHistorical: "050AAA2B-43EA-4952-936C-70638D3BCC0D",
    /** The EntityType Guid for Rock.Model.AnalyticsFactAttendance  */
    AnalyticsFactAttendance: "3FCC0DF5-4299-4971-860C-8CB591DA75D8",
    /** The EntityType Guid for Rock.Model.AnalyticsFactFinancialTransaction  */
    AnalyticsFactFinancialTransaction: "6447497F-C40F-41B9-AB5B-A1F14F80DD18",
    /** The EntityType Guid for Rock.Model.AnalyticsSourceAttendance  */
    AnalyticsSourceAttendance: "BCE52831-6FEF-4521-9E4A-AE5C29F20E2F",
    /** The EntityType Guid for Rock.Model.AnalyticsSourceCampus  */
    AnalyticsSourceCampus: "9DE61413-6D38-4F14-AE1B-DB927E07CE56",
    /** The EntityType Guid for Rock.Model.AnalyticsSourceFamilyHistorical  */
    AnalyticsSourceFamilyHistorical: "C9941E89-EC9D-41FF-A892-5016730F22C1",
    /** The EntityType Guid for Rock.Model.AnalyticsSourceFinancialTransaction  */
    AnalyticsSourceFinancialTransaction: "68E1BB08-B30B-49E2-993E-0B5352BB97C5",
    /** The EntityType Guid for Rock.Model.AnalyticsSourceGivingUnit  */
    AnalyticsSourceGivingUnit: "05103BCB-B164-4591-9129-F949A58C04B1",
    /** The EntityType Guid for Rock.Model.AnalyticsSourcePersonHistorical  */
    AnalyticsSourcePersonHistorical: "FC84E469-7E8F-4202-89C3-F27DD41BC132",
    /** The EntityType Guid for Rock.Model.Assessment  */
    Assessment: "6DCD8FF0-4BFD-4AF7-8F4F-E387934775A3",
    /** The  guid for the Rock.Model.AssessmentType entity. */
    AssessmentType: "D17A28AC-F529-4AB0-A790-C21F9E74AC89",
    /** The EntityType Guid for Rock.Model.AssetStorageProvider  */
    AssetStorageProvider: "E0B4BE77-B29F-4BD4-AE45-CF833AC3A482",
    /** The guid for the Rock.Model.Attendance entity. */
    Attendance: "4CCB856F-51E0-4E48-B94A-1705EFBA6C9E",
    /** The EntityType Guid for Rock.Model.AttendanceCheckInSession  */
    AttendanceCheckInSession: "D60A20A7-98A2-45B5-BF7E-A327E4090940",
    /** The EntityType Guid for Rock.Model.AttendanceCode  */
    AttendanceCode: "D5ADC6D3-9AA0-4AC6-9762-A703EE684934",
    /** The EntityType Guid for Rock.Model.AttendanceOccurrence  */
    AttendanceOccurrence: "0F6FD7F1-7AF5-4135-843F-E34948D4EA28",
    /** The guid for the Rock.Model.Attribute entity. */
    Attribute: "5997C8D3-8840-4591-99A5-552919F90CBD",
    /** The EntityType Guid for Rock.Model.AttributeMatrix  */
    AttributeMatrix: "028228F0-B1D9-4DE5-9E6A-F898C34DDAB8",
    /** The EntityType Guid for Rock.Model.AttributeMatrixItem  */
    AttributeMatrixItem: "3C9D5021-0484-4846-AEF6-B6216D26C3C8",
    /** The EntityType Guid for Rock.Model.AttributeMatrixTemplate  */
    AttributeMatrixTemplate: "20B90F35-70C1-4ADC-A908-A4254C15373D",
    /** The EntityType Guid for Rock.Model.AttributeQualifier  */
    AttributeQualifier: "EC7EB9AC-8B52-4A3D-8587-4A08050780CC",
    /** The EntityType Guid for Rock.Model.AttributeValue  */
    AttributeValue: "D2BDCCF0-D3F4-4F29-B286-DA5B7BFA41C6",
    /** The EntityType Guid for Rock.Model.AttributeValueHistorical  */
    AttributeValueHistorical: "D940AA57-D977-4B75-B4BE-7C2EB40B26A4",
    /** The EntityType Guid for Rock.Model.Audit  */
    Audit: "5DE389E2-4E25-4BB0-8292-67A94ECB379B",
    /** The EntityType Guid for Rock.Model.AuditDetail  */
    AuditDetail: "00A4323F-4A05-4E6A-8480-35D8B7BB6615",
    /** The EntityType Guid for Rock.Model.Auth  */
    Auth: "84855F4E-9865-4F1B-B420-939318272004",
    /** The EntityType Guid for Rock.Model.AuthAuditLog  */
    AuthAuditLog: "6AC9997F-B238-4A67-933E-D80E1551704D",
    /** The EntityType Guid for Rock.Model.AuthClaim  */
    AuthClaim: "A6924EE0-509B-461E-8127-DBF5C4FE30DA",
    /** The EntityType Guid for Rock.Model.AuthClient  */
    AuthClient: "CBD66C3A-959A-4A0B-926C-C3ADE43066B1",
    /** The EntityType Guid for Rock.Model.AuthScope  */
    AuthScope: "8926FE3B-5AB6-4E48-8191-09EB1682F743",
    /** The database authentication provider */
    AuthenticationDatabase: "4E9B798F-BB68-4C0E-9707-0928D15AB020",
    /** The passwordless authentication provider */
    AuthenticationPasswordless: "2D037783-09BD-48BA-8C1D-626B0BC82495",
    /** The pin authentication provider */
    AuthenticationPin: "1FB5A259-F45C-4857-AF3D-3B9E32DB0EEE",
    /** The EntityType Guid for Rock.Model.BackgroundCheck  */
    BackgroundCheck: "6D3A2293-BA7E-44D9-B5B3-5B85DA0EECAC",
    /** The guid for the Rock.Model.Badge entity */
    Badge: "99300129-6F4C-45B2-B486-71123F046289",
    /** The benevolence request */
    BenevolenceRequest: "CF0CE5C1-9286-4310-9B50-10D040F8EBD2",
    /** The EntityType Guid for Rock.Model.BenevolenceRequestDocument  */
    BenevolenceRequestDocument: "3D627F51-E262-454B-95A0-2EF97103BCE1",
    /** The EntityType Guid for Rock.Model.BenevolenceResult  */
    BenevolenceResult: "A4929A2D-5B83-4535-A1D4-8A2C84FBA581",
    /** The guid for the Rock.Model.BenevolenceType entity. */
    BenevolenceType: "9DB5D35A-F2DF-4AFF-AB9F-06C2EB587C0D",
    /** The EntityType Guid for Rock.Model.BenevolenceWorkflow  */
    BenevolenceWorkflow: "1F27A8E2-C40A-4C8D-9F22-55BC24B98D80",
    /** The EntityType Guid for Rock.Model.BinaryFile  */
    BinaryFile: "9BB1A349-5998-47C1-97D5-D6CC00275662",
    /** The EntityType Guid for Rock.Model.BinaryFileData  */
    BinaryFileData: "EA647542-1E0F-4DAE-9537-65E3FFEE8792",
    /** The EntityType Guid for Rock.Model.BinaryFileType  */
    BinaryFileType: "62AF597F-F193-412B-94EA-291CF713327D",
    /** The Block entity type */
    Block: "D89555CA-9AE4-4D62-8AF1-E5E463C1EF65",
    /** The EntityType Guid for Rock.Model.BlockType  */
    BlockType: "04768EDF-C0CD-4950-B629-4D2370B57C99",
    /** The campus */
    Campus: "00096BED-9587-415E-8AD4-4E076AE8FBF0",
    /** The EntityType Guid for Rock.Model.CampusSchedule  */
    CampusSchedule: "134B8879-CD7C-4872-8065-882AA3721C2D",
    /** The EntityType Guid for Rock.Model.CampusTopic  */
    CampusTopic: "0FFDCB0B-B435-4E66-9085-2750534E706A",
    /** The EntityType Guid for Rock.Model.Category  */
    Category: "1D68154E-EC76-44C8-9813-7736B27AECF9",
    /** The checkr provider */
    CheckrProvider: "8D9DE88A-C649-47B2-BA5C-92A24F60AE61",
    /** The EntityType Guid for Rock.Model.Communication  */
    Communication: "C4CCBD91-1264-48BF-BC33-92751C8948B5",
    /** The EntityType Guid for Rock.Model.CommunicationAttachment  */
    CommunicationAttachment: "4271BFB1-AF05-4B6C-8931-032EB02DD760",
    /** The guid for the email communication medium */
    CommunicationMediumEmail: "5A653EBE-6803-44B4-85D2-FB7B8146D55D",
    /** The guid for the push notification communication medium */
    CommunicationMediumPushNotification: "3638C6DF-4FF3-4A52-B4B8-AFB754991597",
    /** The guid for the email communication medium */
    CommunicationMediumSms: "4BC02764-512A-4A10-ACDE-586F71D8A8BD",
    /** The EntityType Guid for Rock.Model.CommunicationRecipient  */
    CommunicationRecipient: "3EC89B90-6692-451E-A48F-0D2ADEBA05BC",
    /** The EntityType Guid for Rock.Model.CommunicationResponse  */
    CommunicationResponse: "DB449144-6045-4B11-AA55-ECF286B117A9",
    /** The EntityType Guid for Rock.Model.CommunicationResponseAttachment  */
    CommunicationResponseAttachment: "2F34E79E-F158-4693-85C4-87FF75D3AFE4",
    /** The guid for Rock.Model.CommunicationTemplate */
    CommunicationTemplate: "A9493AFE-4316-4651-800D-5028E4C7444D",
    /** The EntityType Guid for Rock.Model.CommunicationTemplateAttachment  */
    CommunicationTemplateAttachment: "0DEA0BC5-2AF2-4E06-92CF-DCCD4D3FF011",
    /** The guid for the Rock.Model.ConnectionActivityType entity */
    ConnectionActivityType: "97B143F0-CB9D-4652-8FF1-FF2FA1EA4945",
    /** The guid for the Rock.Model.ConnectionOpportunity entity */
    ConnectionOpportunity: "79F64363-BC90-4109-9D31-A5EEB397CB2F",
    /** The guid for the Rock.Model.ConnectionOpportunityCampus entity */
    ConnectionOpportunityCampus: "E656E8B3-12AB-476E-AA63-5F9B76F64A08",
    /** The EntityType Guid for Rock.Model.ConnectionOpportunityConnectorGroup  */
    ConnectionOpportunityConnectorGroup: "2ADBE499-C9EC-479B-B33B-6E92BDE09FD1",
    /** The guid for the Rock.Model.ConnectionOpportunityGroup entity */
    ConnectionOpportunityGroup: "CD3F425C-9B36-4433-9C38-D58DE42C9F65",
    /** The EntityType Guid for Rock.Model.ConnectionOpportunityGroupConfig  */
    ConnectionOpportunityGroupConfig: "59756122-B779-4A4E-9CE7-6A4468AA9524",
    /** The guid for the Rock.Model.ConnectionRequest entity */
    ConnectionRequest: "36B0D0C7-8125-48FA-9DA2-729AAA65F718",
    /** The guid for the Rock.Model.ConnectionRequestActivity entity */
    ConnectionRequestActivity: "3248F40D-7661-42CC-AD9B-EF63322937B7",
    /** The guid for the Rock.Model.ConnectionRequestWorkflow entity */
    ConnectionRequestWorkflow: "C69D1C9F-5521-4C83-8FE9-5044ECC2CE65",
    /** The guid for the Rock.Model.ConnectionStatus entity */
    ConnectionStatus: "F3840C8B-63BF-4F98-AC4A-9336896E589B",
    /** The EntityType Guid for Rock.Model.ConnectionStatusAutomation  */
    ConnectionStatusAutomation: "ACF794C7-F12D-42DF-85C5-089A28993EE6",
    /** The guid for the Rock.Model.ConnectionType entity */
    ConnectionType: "B1E52EAD-65BD-4C4D-BCCD-73368067621D",
    /** The guid for the Rock.Model.ConnectionWorkflow entity */
    ConnectionWorkflow: "4EB8711F-7301-4699-A223-0505A7CEB20A",
    /** The content channel type */
    ContentChannel: "44484685-477E-4668-89A6-84F29739EB68",
    /** The content channel item type */
    ContentChannelItem: "BF12AE64-21FB-433B-A8A4-E40E8C426DDA",
    /** The EntityType Guid for Rock.Model.ContentChannelItemAssociation  */
    ContentChannelItemAssociation: "7C86EED3-C3F9-4B25-887B-F732FE3C35F0",
    /** The EntityType Guid for Rock.Model.ContentChannelItemSlug  */
    ContentChannelItemSlug: "2FF2F1C3-A440-4D24-8FB8-2B0D9436EA75",
    /** The EntityType Guid for Rock.Model.ContentChannelType  */
    ContentChannelType: "D5992F79-7FB8-49FF-82AB-E8CB2CEC1E74",
    /** The guid for the Rock.Model.ContentCollection entity */
    ContentCollection: "AD7B9219-1B47-4164-9DD1-90F0AF588CB8",
    /** The guid for the Rock.Model.ContentCollectionSource entity */
    ContentCollectionSource: "46BD0E73-14B3-499D-B8BE-C0EF6BDCD733",
    /** The EntityType Guid for Rock.Model.DataViewFilter  */
    DataViewFilter: "507E646B-9943-4DD6-8FB7-8BA9F95E6BD0",
    /** The guid for the Rock.Model.DataView entity. */
    Dataview: "57F8FA29-DCF1-4F74-8553-87E90F234139",
    /** The guid for the Rock.Model.DefinedType entity. */
    DefinedType: "6028D502-79F4-4A74-9323-525E90F900C7",
    /** The guid for Rock.Model.DefinedValue entity */
    DefinedValue: "53D4BF38-C49E-4A52-8B0E-5E016FB9574E",
    /** The EntityType Guid for Rock.Model.Device  */
    Device: "C06EE1FE-AF12-410A-A364-7A366CD72414",
    /** The EntityType Guid for Rock.Model.Document  */
    Document: "7CEFA340-9D98-4B2C-B462-313C61944B6C",
    /** The EntityType Guid for Rock.Model.DocumentType  */
    DocumentType: "18CF366F-46B6-49CA-B557-BCABD6BBD175",
    /** The EntityType Guid for Rock.Model.EntityCampusFilter  */
    EntityCampusFilter: "A736A9FB-F2A5-4458-B126-FAD6BD3F3B78",
    /** The EntityType Guid for Rock.Model.EntitySet  */
    EntitySet: "50E3F9C8-4010-41AF-8F61-08308DC44640",
    /** The EntityType Guid for Rock.Model.EntitySetItem  */
    EntitySetItem: "1F9D13F9-BF55-48BE-BEA9-0939CD6FDA5B",
    /** The guid for Rock.Model.EntityType entity. */
    EntityType: "A2277FBA-D09F-4D07-B0AB-1C650C25A7A7",
    /** The guid for Rock.Model.EventCalendar entity. */
    EventCalendar: "E67D8D6D-4FE6-48D5-A940-A39213047314",
    /** The EntityType Guid for Rock.Model.EventCalendarContentChannel  */
    EventCalendarContentChannel: "B8631058-DAC3-4164-9A50-9E732B0C3882",
    /** The EntityType Guid for Rock.Model.EventCalendarItem  */
    EventCalendarItem: "E37FB26F-03F6-48DA-8E96-F412616F5EE4",
    /** The EntityType Guid for Rock.Model.EventItem  */
    EventItem: "6A58AD11-3491-84AE-4896-8F39906EA65E",
    /** The EntityType Guid for Rock.Model.EventItemAudience  */
    EventItemAudience: "22394315-E21B-40AF-AFDA-75D9F5DAD721",
    /** The EntityType Guid for Rock.Model.EventItemOccurrence  */
    EventItemOccurrence: "71632E1A-1E7F-42B9-A630-EC99F375303A",
    /** The EntityType Guid for Rock.Model.EventItemOccurrenceChannelItem  */
    EventItemOccurrenceChannelItem: "378A9559-BD86-45A8-B218-2C5D4CF3D770",
    /** The EntityType Guid for Rock.Model.EventItemOccurrenceGroupMap  */
    EventItemOccurrenceGroupMap: "1479D2B7-65C0-4E98-9E70-0848422FA00C",
    /** The EntityType Guid for Rock.Model.ExceptionLog  */
    ExceptionLog: "F61A9F8A-6DA5-49C6-BC8E-5545C5EEDA21",
    /** The EntityType Guid for Rock.Model.FieldType  */
    FieldType: "54018EB6-868C-477D-8B6A-455A6115B30B",
    /** The guid for the Rock.Model.FinancialAccount entity. */
    FinancialAccount: "798BCE48-6AA7-4983-9214-F9BCEFB4521D",
    /** The guid for the Rock.Model.FinancialBatch entity. */
    FinancialBatch: "BDD09C8E-2C52-4D08-9062-BE7D52D190C2",
    /** The EntityType Guid for Rock.Model.FinancialGateway  */
    FinancialGateway: "122EFE60-84A6-4C7A-A852-30E4BD89A662",
    /** The guid for the Test Financial Gateway entity type */
    FinancialGatewayTestGateway: "C22B0247-7C9F-411B-A1F5-0051FCBAC199",
    /** The Test Redirection Gateway entity type */
    FinancialGatewayTestRedirectionGateway: "AB3C5BF6-4D99-4289-84AF-3EF798849705",
    /** The EntityType Guid for Rock.Model.FinancialPaymentDetail  */
    FinancialPaymentDetail: "F3659077-43FD-4805-BC42-BC8A3F9C3008",
    /** The EntityType Guid for Rock.Model.FinancialPersonBankAccount  */
    FinancialPersonBankAccount: "EC1AE861-BDFE-4A08-9741-2E1D2293456F",
    /** The EntityType Guid for Rock.Model.FinancialPersonSavedAccount  */
    FinancialPersonSavedAccount: "F5244E64-53DB-4707-A398-D248616A776D",
    /** The EntityType Guid for Rock.Model.FinancialPledge  */
    FinancialPledge: "CE8060E6-21E7-49F5-BFBE-F632C816C232",
    /** The guid for the Rock.Model.FinancialScheduledTransaction entity. */
    FinancialScheduledTransaction: "76824E8A-CCC4-4085-84D9-8AF8C0807E20",
    /** The EntityType Guid for Rock.Model.FinancialScheduledTransactionDetail  */
    FinancialScheduledTransactionDetail: "A206615F-3FB5-48DF-B606-86AE8716FD57",
    /** The EntityType Guid for Rock.Model.FinancialStatementTemplate  */
    FinancialStatementTemplate: "85442202-13BC-46C5-B1E9-43018DEA20F1",
    /** The guid for the Rock.Model.FinancialTransaction entity. */
    FinancialTransaction: "2C1CB26B-AB22-42D0-8164-AEDEE0DAE667",
    /** The EntityType Guid for Rock.Model.FinancialTransactionAlert  */
    FinancialTransactionAlert: "0E60F95E-70B5-4A06-9BEE-80ED9F12F25A",
    /** The EntityType Guid for Rock.Model.FinancialTransactionAlertType  */
    FinancialTransactionAlertType: "2E237B04-5B2A-40F1-8CD3-52673C104305",
    /** The guid for the Rock.Model.FinancialTransactionDetail entity. */
    FinancialTransactionDetail: "AC4AC28B-8E7E-4D7E-85DB-DFFB4F3ADCCE",
    /** The EntityType Guid for Rock.Model.FinancialTransactionImage  */
    FinancialTransactionImage: "78DCA7EE-C5FE-49AE-9995-0E254CC8E2A2",
    /** The EntityType Guid for Rock.Model.FinancialTransactionRefund  */
    FinancialTransactionRefund: "7616E2AF-CEF2-44A5-B27F-3E70EC8B70FA",
    /** The EntityType Guid for Rock.Model.Following  */
    Following: "D9AD7A30-92F2-467B-A3F9-37CA246F90BD",
    /** The EntityType Guid for Rock.Model.FollowingEventNotification  */
    FollowingEventNotification: "21BA6002-1FB0-45C7-BCA6-D6629EC8AB52",
    /** The EntityType Guid for Rock.Model.FollowingEventSubscription  */
    FollowingEventSubscription: "2EEA3DF1-1FBE-472C-85AF-6D952DFC4684",
    /** The EntityType Guid for Rock.Model.FollowingEventType  */
    FollowingEventType: "8A0D208B-762D-403A-A972-3A0F079866D4",
    /** The EntityType Guid for Rock.Model.FollowingSuggested  */
    FollowingSuggested: "EC14B80A-3776-4134-884D-031A89C0EF03",
    /** The EntityType Guid for Rock.Model.FollowingSuggestionType  */
    FollowingSuggestionType: "CC7DF118-86A1-4F90-82D8-0DAE9CD37343",
    /** The guid for the Rock.Model.Group entity. */
    Group: "9BBFDA11-0D22-40D5-902F-60ADFBC88987",
    /** The EntityType Guid for Rock.Model.GroupDemographicType  */
    GroupDemographicType: "9AE7A87B-E274-4FF5-BEFD-55CCF603CE13",
    /** The EntityType Guid for Rock.Model.GroupDemographicValue  */
    GroupDemographicValue: "C9CED7B0-88BF-40D1-83D1-A58B3C57A2E1",
    /** The EntityType Guid for Rock.Model.GroupHistorical  */
    GroupHistorical: "422A2EF2-9D74-4308-8CDB-D5FA4B6A01FF",
    /** The EntityType Guid for Rock.Model.GroupLocation  */
    GroupLocation: "26248EE7-09F3-4578-A1D6-47E01D91D6EF",
    /** The EntityType Guid for Rock.Model.GroupLocationHistorical  */
    GroupLocationHistorical: "03128778-5E7D-4FE4-9C7A-929936E06F90",
    /** The EntityType Guid for Rock.Model.GroupLocationHistoricalSchedule  */
    GroupLocationHistoricalSchedule: "3BC646E4-CA5E-47D6-BC6D-4BBFAAEDAD8B",
    /** The guid for the Rock.Model.GroupMember entity. */
    GroupMember: "49668B95-FEDC-43DD-8085-D2B0D6343C48",
    /** The EntityType Guid for Rock.Model.GroupMemberAssignment  */
    GroupMemberAssignment: "22BF14ED-E882-4BB0-9328-D12545BF5F61",
    /** The EntityType Guid for Rock.Model.GroupMemberHistorical  */
    GroupMemberHistorical: "233EA15D-8FEE-40FE-9772-D369D34E3A8D",
    /** The EntityType Guid for Rock.Model.GroupMemberRequirement  */
    GroupMemberRequirement: "FF1B2C4B-0F2D-4D9B-9E85-7336CCC24A62",
    /** The EntityType Guid for Rock.Model.GroupMemberScheduleTemplate  */
    GroupMemberScheduleTemplate: "D84ED719-B659-433C-BFA0-E798E52C6B24",
    /** The EntityType Guid for Rock.Model.GroupMemberWorkflowTrigger  */
    GroupMemberWorkflowTrigger: "3CE3406A-1FFE-4CCA-A8D5-916EEF800D76",
    /** The EntityType Guid for Rock.Model.GroupRequirement  */
    GroupRequirement: "CFC7DE86-222E-4669-83C2-A3F5B04CB5D6",
    /** The EntityType Guid for Rock.Model.GroupRequirementType  */
    GroupRequirementType: "8E67E852-D1BF-485C-9898-09F19998CC40",
    /** The EntityType Guid for Rock.Model.GroupScheduleExclusion  */
    GroupScheduleExclusion: "047D57EE-1B06-455F-86EA-D96B8325C77D",
    /** The EntityType Guid for Rock.Model.GroupSync  */
    GroupSync: "1C011499-1122-4429-9AFA-6578798E18A9",
    /** The EntityType Guid for Rock.Model.GroupType  */
    GroupType: "0DD30B04-01CF-4B38-8E83-BE661E2F7286",
    /** The EntityType Guid for Rock.Model.GroupTypeRole  */
    GroupTypeRole: "D155C373-9E47-4C6A-BADD-792F31AF5FBA",
    /** The guid for the Rock.Model.History entity. */
    History: "546D5F43-1184-47C9-8265-2D7BF4E1BCA5",
    /** The EntityType Guid for Rock.Model.HtmlContent  */
    HtmlContent: "FB30EC4C-7DCC-41A4-94AB-E728A8CE537B",
    /** The HTTP module component */
    HttpModuleComponent: "EDE69F48-5E05-4260-B360-DA37DFD1AB83",
    /** The EntityType Guid for Rock.Model.IdentityVerification  */
    IdentityVerification: "C76071B0-0C2F-4A3F-88BF-08B2E006C614",
    /** The EntityType Guid for Rock.Model.IdentityVerificationCode  */
    IdentityVerificationCode: "3FCB8972-C319-4262-9D6E-3D60E1C4E463",
    /** The guid for Rock.Model.Interaction */
    Interaction: "3BB4B095-2DE4-4009-8FA2-705BF284F7B7",
    /** The EntityType Guid for Rock.Model.InteractionChannel  */
    InteractionChannel: "08606092-5FF5-4A34-A7A6-3DEE43F2843A",
    /** The EntityType Guid for Rock.Model.InteractionComponent  */
    InteractionComponent: "ACE6145B-57D6-4694-972F-EC43AF776DE7",
    /** The EntityType Guid for Rock.Model.InteractionDeviceType  */
    InteractionDeviceType: "C1A24534-C77F-41A8-BCA9-73ABA57348E3",
    /** The EntityType Guid for Rock.Model.InteractionSession  */
    InteractionSession: "338025DE-C16F-47BB-BA31-6DE0C59E59AA",
    /** The EntityType Guid for Rock.Model.InteractionSessionLocation  */
    InteractionSessionLocation: "790EC7AC-7443-466C-A07E-F702D86B9E1B",
    /** The EntityType Guid for Rock.Achievement.Component.InteractionSourcedAccumulativeAchievement  */
    InteractionSourcedAchievementComponent: "1F2B13BE-EFAA-4D4E-B2D2-D221B51AEA67",
    /** The EntityType Guid for Rock.Model.InteractiveExperience */
    InteractiveExperience: "3D90E693-476E-4DFC-B958-A28D1DD370BF",
    /** The EntityType Guid for Rock.Model.InteractiveExperienceAction */
    InteractiveExperienceAction: "8635E7E7-3576-47FF-92DE-30A69EB5D011",
    /** The EntityType Guid for Rock.Model.InteractiveExperienceAnswer */
    InteractiveExperienceAnswer: "D11DA9D4-8887-4EC2-B396-78556926DE89",
    /** The EntityType Guid for Rock.Model.InteractiveExperienceOccurrence */
    InteractiveExperienceOccurrence: "2D1263A1-A3E7-4568-AA4B-C1234824188D",
    /** The EntityType Guid for Rock.Model.InteractiveExperienceSchedule */
    InteractiveExperienceSchedule: "D23B4DCF-545A-490F-AEAD-BA78A8FB4028",
    /** The EntityType Guid for Rock.Model.InteractiveExperienceScheduleCampus */
    InteractiveExperienceScheduleCampus: "ABEF4137-F25B-4B2E-AF01-2CEFF704FC11",
    /** The EntityType Guid for Rock.Model.LavaShortcode (well known as of v14) */
    LavaShortcode: "7574A473-3326-4973-8DF6-C7BF5F64EB36",
    /** The EntityType Guid for LavaShortcodeCategory 'joiner' table Rock.Model.LavaShortcodeConfiguration */
    LavaShortcodeCategory: "6CFE20AD-F883-4F53-A678-0D048406299D",
    /** The EntityType Guid for Rock.Model.Layout */
    Layout: "9DACC861-FED4-47FC-946D-D6A120FF6D56",
    /** The EntityType Guid for Rock.Model.Location  */
    Location: "0D6410AD-C83C-47AC-AF3D-616D09EDF63B",
    /** The EntityType Guid for Rock.Model.MediaAccount  */
    MediaAccount: "CD35F034-AC18-40D5-B703-6BF16D79C51C",
    /** The EntityType Guid for Rock.Model.MediaElement  */
    MediaElement: "F4506B5D-F22C-4D3F-8205-FE48A9B7584B",
    /** The EntityType Guid for Rock.Model.MediaFolder  */
    MediaFolder: "B28FC79F-9FEE-4BE4-801D-96B9246E6043",
    /** The guid for the Rock.Model.MergeTemplate entity */
    MergeTemplate: "CD1DB988-6891-4B0F-8D1B-B0A311A3BC3E",
    /** The EntityType Guid for Rock.Model.MetaFirstNameGenderLookup  */
    MetaFirstNameGenderLookup: "FA96E086-811E-4FE0-BECA-F7A593F9FB05",
    /** The EntityType Guid for Rock.Model.MetaLastNameLookup  */
    MetaLastNameLookup: "0FB0F456-6999-426D-9C86-973D54749565",
    /** The EntityType Guid for Rock.Model.MetaNickNameLookup  */
    MetaNickNameLookup: "5FCBE899-3756-4F64-8540-CE37EA9EED45",
    /** The EntityType Guid for Rock.Model.Metric  */
    Metric: "1C5489C6-82F9-4967-8425-52545CE8AF90",
    /** The EntityType Guid for Rock.Model.MetricPartition  */
    MetricPartition: "82ED733F-BAD8-4D8D-BCB7-10A6433F452A",
    /** The EntityType Guid for Rock.Model.MetricValue  */
    MetricValue: "DD0E6F39-3E07-44D0-BE7B-B1AB75AFED2D",
    /** The EntityType Guid for Rock.Model.MetricValuePartition  */
    MetricValuePartition: "FEC12664-C5F2-44E1-9805-1137068AC755",
    /** The guid for the Rock.Model.MetricCategory entity */
    Metriccategory: "3D35C859-DF37-433F-A20A-0FFD0FCB9862",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Prayer.AnswerToPrayer. */
    MobileAnswerToPrayerBlockType: "759AFCA0-9E0B-4A22-A402-CD4499F2A457",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Cms.DailyChallengeEntry */
    MobileCmsDailyChallengeEntry: "E9BC058A-CFE4-498B-A7E7-DD38DC74B30E",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Cms.Hero */
    MobileCmsHeroBlockType: "49BE78CD-2D19-44C4-A6BF-4F3B5D3F97C8",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Cms.StructuredContentView */
    MobileCmsStructuredcontentviewBlockType: "219660C4-8F32-46DA-B8E3-A7A6FA0D6B76",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Communication.CommunicationEntry */
    MobileCommunicationCommunicationentryBlockType: "9A952F9F-F619-4063-B1BB-CFB2E6983C01",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Communication.CommunicationView */
    MobileCommunicationCommunicationviewBlockType: "4AF5FCEF-CBF6-486B-A04D-920E31356B7F",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Connection.ConnectionOpportunityList. */
    MobileConnectionConnectionOpportunityListBlockType: "CB151D80-DBEF-4A1E-A816-3DF4CD2DE45A",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Connection.ConnectionRequestDetail. */
    MobileConnectionConnectionRequestDetailBlockType: "6C9B8E2A-A0B1-4E52-B419-250A77AFBCBF",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Connection.ConnectionRequestList. */
    MobileConnectionConnectionRequestListBlockType: "E1C52624-898F-46EF-98B0-3C06B6D81654",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Connection.ConnectionTypeList. */
    MobileConnectionConnectionTypeListBlockType: "F30667AC-5FAA-429C-AD7F-D4B7C0C5C293",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Content */
    MobileContentBlockType: "B9ADB0A5-62B0-4D74-BDFF-1AA959788602",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.ContentChannelItemList */
    MobileContentChannelItemListBlockType: "6DBF59D6-EB40-43C8-8859-F38254EC3F6D",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.ContentChannelItemView */
    MobileContentChannelItemViewBlockType: "44A8B647-E0A7-42E7-9A75-276310F7E7BB",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Core.Notes */
    MobileCoreNotesBlockType: "2FED71D1-4A60-4EB5-B971-530B5D1FC041",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Core.Search. */
    MobileCoreSearchBlockType: "F81015CD-EBA9-4358-B930-4F1AB29AF879",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Events.CalendarEventItemOccurrenceView */
    MobileEventsCalendareventitemoccurrenceviewBlockType: "04C43693-C524-4679-9F65-047F94A74CAB",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Events.CalendarEventList */
    MobileEventsCalendareventlistBlockType: "6FB9F1F4-5F24-4A22-A6EB-A7FA499179A9",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Events.CalendarView */
    MobileEventsCalendarviewBlockType: "5A26F32F-892E-4E76-B64A-0F54A77C863D",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Events.CommunicationListSubscribe */
    MobileEventsCommunicationListSubscribeBlockType: "C4B81A58-6380-4C38-85E8-0536E584310E",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Events.EventItemOccurrenceListByAudienceLava */
    MobileEventsEventitemoccurrencelistbyaudiencelavaBlockType: "95BAF1B3-5B4B-430C-BDCC-268142C708BD",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Events.LiveExperience */
    MobileEventsLiveexperienceBlockType: "FC408E41-872D-4B71-A08C-513D7500E980",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Events.PrayerSession */
    MobileEventsPrayerSessionBlockType: "BCAF9B7B-2ADE-496B-9303-150F495851FC",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Events.PrayerSessionSetup */
    MobileEventsPrayerSessionSetupBlockType: "51431866-FF92-433C-8B0F-0F6BBAD9BCE7",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Groups.GroupRegistration */
    MobileGroupsGroupAddToGroup: "E0664BDC-9583-44F2-AC8D-23AE48603EAB",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Groups.GroupAttendanceEntry */
    MobileGroupsGroupAttendanceEntryBlockType: "1655E6A9-2BD6-4FA0-8886-D64DCA177FBB",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Groups.GroupEdit */
    MobileGroupsGroupEditBlockType: "DE46759A-CE15-4F27-9FC8-154CD30D4637",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Groups.GroupFinder */
    MobileGroupsGroupFinderBlockType: "15492F6A-344A-484E-AA26-A5E667CBD502",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Groups.GroupMemberEdit */
    MobileGroupsGroupMemberEditBlockType: "61208516-9051-4E0E-AC46-6C8E1F104F3A",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Groups.GroupMemberList */
    MobileGroupsGroupMemberListBlockType: "70652D98-9285-4707-8F46-B7FC48B6503D",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Groups.GroupMemberView */
    MobileGroupsGroupMemberViewBlockType: "3213DCBC-C5EC-4DD2-BB78-19B3636AE842",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Groups.GroupRegistration */
    MobileGroupsGroupRegistrationBlockType: "E0664BDC-9583-44F2-AC8D-23AE48603EAB",
    /** The GUID for entity Rock.Blocks.Types.Mobile.Groups.GroupSchedulePreference */
    MobileGroupsGroupSchedulePreference: "36B341A9-07FC-43A1-970A-E5D4CDB83E6A",
    /** The GUID for entity Rock.Blocks.Types.Mobile.Groups.GroupScheduleSignUp */
    MobileGroupsGroupScheduleSignup: "DE3893A7-C353-4D19-A3FA-8B8EA99984F9",
    /** The GUID for entity Rock.Blocks.Types.Mobile.Groups.GroupScheduleToolbox */
    MobileGroupsGroupScheduleToolbox: "DCC6C7C8-1040-4F0E-94ED-90450E2E9610",
    /** The GUID for entity Rock.Blocks.Types.Mobile.Groups.GroupScheduleUnavailability */
    MobileGroupsGroupScheduleUnavailability: "300E3105-A9C9-4C86-8BD1-CC041B6953C6",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Groups.GroupView */
    MobileGroupsGroupViewBlockType: "564C4D86-C9DF-48D0-84B6-DD3FCC1A5158",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.LavaItemList */
    MobileLavaItemListBlockType: "60AD6D70-8A2A-4CC1-97D5-199300AF77EE",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Login */
    MobileLoginBlockType: "6CE2D3D7-18D8-49FF-8C39-0CA98EB5DEB4",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Prayer.MyPrayerRequests. */
    MobileMyPrayerRequestsBlockType: "E644DE6A-44CA-48AC-BF33-5429DA8052C6",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Prayer.PrayerCardView. */
    MobilePrayerPrayerCardViewBlockType: "0D0F1D7E-2D75-451B-95EE-0610B8F26BBF",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Prayer.PrayerRequestDetails */
    MobilePrayerPrayerRequestDetailsBlockType: "F8E56BC0-E9D1-44A4-9900-46589A1FB784",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.ProfileDetails */
    MobileProfileDetailsBlockType: "A1ED4948-0778-4E13-B434-E97795DDB68B",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Register */
    MobileRegisterBlockType: "4459357F-E422-45D1-855D-C4681101F848",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.Security.OnboardPerson. */
    MobileSecurityOnboardPerson: "C9B7F36A-F70A-4ABF-9422-B18E579F927F",
    /** The GUID for the entity Rock.Blocks.Types.Mobile.WorkflowEntry */
    MobileWorkflowEntryBlockType: "02D2DBA8-5300-4367-B15B-E37DFB3F7D1E",
    /** The MyWell financial gateway */
    MywellFinancialGateway: "E81ED723-E807-4BDE-ADF1-AB9686241637",
    /** The EntityType Guid for Rock.Model.NcoaHistory  */
    NcoaHistory: "1F20AC90-C57E-4DD1-A71B-06312110E56F",
    /** The guid for the Rock.Model.Note entity */
    Note: "53DC1E78-14A5-44DE-903F-6A2CB02164E7",
    /** The EntityType Guid for Rock.Model.NoteAttachment  */
    NoteAttachment: "D090C50E-2FE1-4284-9631-19D06F4AD8B0",
    /** The EntityType Guid for Rock.Model.NoteType  */
    NoteType: "337EED57-D4AB-4EED-BBDB-0CB3A467DBCC",
    /** The EntityType Guid for Rock.Model.NoteWatch  */
    NoteWatch: "A5C129C2-E64D-4B72-B94D-DBA6DA6AC2E3",
    /** The EntityType Guid for Rock.Model.Notification  */
    Notification: "6DB6D280-9740-41FD-B8BD-0AA29E12F4B6",
    /** The EntityType Guid for Rock.Model.NotificationMessage  */
    NotificationMessage: "239ADD2E-2DBF-46A7-BD28-4A2A201D4E7B",
    /** The EntityType Guid for Rock.Model.NotificationMessageType  */
    NotificationMessageType: "36FB1038-8836-429F-BAD4-04D32892D6D0",
    /** The EntityType Guid for Rock.Model.NotificationRecipient  */
    NotificationRecipient: "2ECE2776-0FE2-429D-B655-AB56A2D6EE0B",
    /** The obsidian event registration entry */
    ObsidianEventRegistrationEntry: "06AAC065-BF89-483D-B671-80F0F72779A6",
    /** The obsidian event control gallery */
    ObsidianExampleControlGallery: "7B916FEC-9395-4877-9856-427419C50AB5",
    /** The obsidian event field type gallery */
    ObsidianExampleFieldTypeGallery: "82F9C803-C998-46B2-B354-783D4D1E3B43",
    /** The obsidian form builder detail */
    ObsidianFormBuilderDetailBlockType: "BB44D8ED-DEDC-4C9B-A30D-C636019BC960",
    /** The obsidian form template detail */
    ObsidianFormTemplateDetailBlockType: "4A08BC88-AD45-4106-BDD7-184A14B39B9A",
    /** The guid for the Rock.Model.Page entity */
    Page: "E104DCDF-247C-4CED-A119-8CC51632761F",
    /** The EntityType Guid for Rock.Model.PageContext  */
    PageContext: "5C56B915-8A8B-4747-9D84-EBAF0BACC9A1",
    /** The EntityType Guid for Rock.Model.PageRoute  */
    PageRoute: "42C14361-67B2-472C-95BE-EA8A9C511837",
    /** The EntityType Guid for Rock.Model.PageShortLink  */
    PageShortLink: "83D8C6DF-1D53-438B-93B2-75A2038BBEE6",
    /** The EntityType Guid for Rock.Model.PersistedDataset  */
    PersistedDataset: "9C3064C0-CF9C-4549-9A80-022514B7FF83",
    /** The guid for the Rock.Model.Person entity */
    Person: "72657ED8-D16E-492E-AC12-144C5E7567E7",
    /** The guid for the Rock.Model.PersonAlias entity */
    PersonAlias: "90F5E87B-F0D5-4617-8AE9-EB57E673F36F",
    /** The EntityType Guid for Rock.Model.PersonDuplicate  */
    PersonDuplicate: "20B2B2B6-38C3-4302-9200-63DD4C78687B",
    /** The guid for the Rock.Workflow.Action.PersonGetCampusTeamMember entity */
    PersonGetCampusTeamMember: "6A4F7FEC-3D49-4A31-882C-2D10DB84231E",
    /** The GUID for the Rock.Follow.Event.PersonNoteAdded entity */
    PersonNoteAdded: "C4AB0F1B-E036-4D14-BFB7-30BAF12D648A",
    /** The GUID for the Rock.Follow.Event.PersonPrayerRequest entity */
    PersonPrayerRequest: "DAE05FAE-A26F-465A-836C-BAA0EFA1267B",
    /** The GUID for the Rock.Model.PersonPreference entity */
    PersonPreference: "FDCF766C-F36B-403B-89F3-7030DA65507E",
    /** The EntityType Guid for Rock.Model.PersonPreviousName  */
    PersonPreviousName: "80AC80E1-F769-4E34-9937-E2FEEF2B60EE",
    /** The EntityType Guid for Rock.Model.PersonScheduleExclusion  */
    PersonScheduleExclusion: "07204F06-C09C-4B37-921A-C31C042938B9",
    /** The EntityType Guid for Rock.Model.PersonSearchKey  */
    PersonSearchKey: "914FE998-4F61-4005-ACCC-A8D0433CAD47",
    /** The guid for the Rock.Model.PersonSignal entity */
    PersonSignal: "0FFF77A1-E92D-4A05-8B36-1D2B6D46660F",
    /** The EntityType Guid for Rock.Model.PersonToken  */
    PersonToken: "846B2BCE-7101-46B9-B89C-CD68073712CE",
    /** The EntityType Guid for Rock.Model.PersonViewed  */
    PersonViewed: "AF13DF44-4EE7-4492-AEE4-6BD2A62F9C76",
    /** The EntityType Guid for Rock.Model.PersonalDevice  */
    PersonalDevice: "E9CD3369-E087-4809-9952-F2DCD6B8816B",
    /** The EntityType Guid for Rock.Model.PersonalLink  */
    PersonalLink: "F858CF72-ECCC-4DC6-AD72-7B82467B3466",
    /** The EntityType Guid for Rock.Model.PersonalLinkSection  */
    PersonalLinkSection: "42411FC0-7ACD-42E9-A8A1-BCEA78AF0AAF",
    /** The EntityType Guid for Rock.Model.PersonalLinkSectionOrder  */
    PersonalLinkSectionOrder: "648325DC-1555-44B7-AFA4-1971E57F7E11",
    /** The EntityType Guid for Rock.Model.PersonalizationSegment  */
    PersonalizationSegment: "368A3581-C8C4-4960-901A-9587864226F3",
    /** The EntityType Guid for Rock.Model.PhoneNumber  */
    PhoneNumber: "AD7E27CB-036D-40C6-B352-81B38BFAE798",
    /** The EntityType Guid for Rock.Model.PluginMigration  */
    PluginMigration: "F239557E-C7A8-4D1F-82CC-55CDD0ACA3C8",
    /** The EntityType Guid for Rock.Model.PrayerRequest  */
    PrayerRequest: "F13C8FD2-7702-4C79-A6A9-86440DD5DE13",
    /** The protect my ministry provider */
    ProtectMyMinistryProvider: "C16856F4-3C6B-4AFB-A0B8-88A303508206",
    /** The guid for the Rock.Model.Registration entity */
    Registration: "D2F294C6-E161-4A56-85C7-CD74D535F61A",
    /** The EntityType Guid for Rock.Model.RegistrationInstance  */
    RegistrationInstance: "5CD9C0C8-C047-61A0-4E36-0FDB8496F066",
    /** The EntityType Guid for Rock.Model.RegistrationRegistrant  */
    RegistrationRegistrant: "8A25E5CE-1B4F-4825-BCEA-216167836305",
    /** The EntityType Guid for Rock.Model.RegistrationRegistrantFee  */
    RegistrationRegistrantFee: "AB66F63A-3E79-438F-8C52-C9A8C70A0511",
    /** The EntityType Guid for Rock.Model.RegistrationSession  */
    RegistrationSession: "6846744B-2623-4EF3-A20F-8027C4839094",
    /** The guid for the Rock.Model.RegistrationTemplate entity */
    RegistrationTemplate: "A01E3E99-A8AD-4C6C-BAAC-98795738BA70",
    /** The EntityType Guid for Rock.Model.RegistrationTemplateDiscount  */
    RegistrationTemplateDiscount: "88D94ECB-FCEE-4A00-ACB9-FF90BDBA7A17",
    /** The EntityType Guid for Rock.Model.RegistrationTemplateFee  */
    RegistrationTemplateFee: "2DB3A441-6CA1-49D1-BB25-C744E2FFA457",
    /** The EntityType Guid for Rock.Model.RegistrationTemplateFeeItem  */
    RegistrationTemplateFeeItem: "CC1DB3FF-A145-49CE-ADC0-B8960EBF37D4",
    /** The EntityType Guid for Rock.Model.RegistrationTemplateForm  */
    RegistrationTemplateForm: "2F0B3A6A-4E47-45A8-A331-7234CE711356",
    /** The EntityType Guid for Rock.Model.RegistrationTemplateFormField  */
    RegistrationTemplateFormField: "A773CAA2-2211-416B-BDD7-D907085B4441",
    /** The EntityType Guid for Rock.Model.RegistrationTemplatePlacement  */
    RegistrationTemplatePlacement: "CCE05820-5854-47A4-ACE3-05DF48479939",
    /** The EntityType Guid for Rock.Model.RelatedEntity  */
    RelatedEntity: "BD29E403-BA47-4688-BE29-45A38CE8BD03",
    /** The guid for the Rock.Model.Reminder entity */
    Reminder: "46CC0D74-BE46-4D5D-A6F1-0811645721AC",
    /** The guid for the Rock.Model.ReminderType entity */
    ReminderType: "B2B0B6F3-0E3B-40CF-BA93-FBB99D50788C",
    /** The EntityType Guid for Rock.Model.RemoteAuthenticationSession  */
    RemoteAuthenticationSession: "2FDEE857-08BE-47F3-8E86-B2027F545EE8",
    /** The EntityType Guid for Rock.Model.Report  */
    Report: "F1F22D3E-FEFA-4C84-9FFA-9E8ACE60FCE7",
    /** The EntityType Guid for Rock.Model.ReportField  */
    ReportField: "6B541BAA-44B7-48BA-937A-543866905689",
    /** The LiquidSelect DataSelect field for Reporting */
    ReportingDataselectLiquidselect: "C130DC52-CA31-45EE-A4F2-6C53A838EF3D",
    /** The EntityType Guid for Rock.Model.RequestFilter  */
    RequestFilter: "97FAC672-37A4-4185-B1D4-C68426C625B1",
    /** The EntityType Guid for Rock.Model.RestAction  */
    RestAction: "D4F7F055-5351-4ADF-9F8D-4802CAD6CC9D",
    /** The EntityType Guid for Rock.Model.RestController  */
    RestController: "65CDFD5B-A9AA-48FA-8D22-669612D5EA7D",
    /** The guid for the Rock.Model.Schedule entity */
    Schedule: "0B2C38A7-D79C-4F85-9757-F1B045D32C8A",
    /** The EntityType Guid for Rock.Model.ScheduleCategoryExclusion  */
    ScheduleCategoryExclusion: "E04681EB-7A85-441B-B794-82B025FFB5D4",
    /** The guid for the Rock.Workflow.Action.SendEmail entity */
    SendEmail: "66197B01-D1F0-4924-A315-47AD54E030DE",
    /** The Service Job entity type */
    ServiceJob: "52766196-A72F-4F60-997A-78E19508843D",
    /** The EntityType Guid for Rock.Model.ServiceJobHistory  */
    ServiceJobHistory: "D6A7C6E0-004F-4F38-9DCA-16E645F5EDF4",
    /** The EntityType Guid for Rock.Model.ServiceLog  */
    ServiceLog: "B5C26A04-E374-495A-AEC6-171C2D2CBD60",
    /** The Signal Type entity type */
    SignalType: "0BA03B9B-E974-4526-9B21-5037424B6D16",
    /** The EntityType Guid for Rock.Model.SignatureDocument  */
    SignatureDocument: "C1724719-1C03-4D0C-8A66-E3545138F57F",
    /** The EntityType Guid for Rock.Model.SignatureDocumentTemplate  */
    SignatureDocumentTemplate: "3F9828CC-8224-4AB0-98A5-6D60001EBE32",
    /** Rock.Model.Site EntityType guid */
    Site: "7244C10B-5D87-467B-A7F5-12DC29910CA8",
    /** The EntityType Guid for Rock.Model.SiteDomain  */
    SiteDomain: "4C4CD7DD-427C-45EC-9651-F8250D3CAB5F",
    /** The EntityType Guid for Rock.Model.SmsAction  */
    SmsAction: "1F5E26BE-0ED4-4250-8FFC-1DED5E9EACF0",
    /** The SMS Conversation Action */
    SmsActionConversation: "E808A9FD-06A7-4FB2-AD01-C826A53B0ABB",
    /** The EntityType Guid for Rock.Model.SmsPipeline  */
    SmsPipeline: "64DA3A06-FD39-4E5B-8126-38404FB0092A",
    /** The EntityType Guid for Rock.Model.Snippet */
    Snippet: "93548852-201B-4EF6-AF27-BBF535A2CC2B",
    /** The EntityType Guid for Rock.Model.SnippetType  */
    SnippetType: "FD4C72DE-6B5D-4EB5-9438-385E2E15AF05",
    /** The guid for the Step entity type */
    Step: "8EADB0DC-17F4-4541-A46E-53F89E21A622",
    /** The Step Flow entity type */
    StepFlow: "308D8252-7712-4A45-8DE4-737C3EEAEA8F",
    /** The guid for the Step program entity */
    StepProgram: "E89F9528-A74E-41B7-8B65-B56B4CE7A122",
    /** The EntityType Guid for Rock.Achievement.Component.StepProgramAchievement  */
    StepProgramAchievementComponent: "7140BAE3-89E9-423E-A691-6E13544203CA",
    /** The EntityType Guid for Rock.Model.StepProgramCompletion  */
    StepProgramCompletion: "B7A9C37D-2B04-4FD3-91BD-DFCA50B3CC8C",
    /** The EntityType Guid for Rock.Model.StepStatus  */
    StepStatus: "6C270D6A-F126-445B-93F0-5079A968BF4E",
    /** The EntityType Guid for Rock.Model.StepType  */
    StepType: "5E795620-9F16-49D2-9030-947C0E348A8E",
    /** The EntityType Guid for Rock.Model.StepTypePrerequisite  */
    StepTypePrerequisite: "F2181FCD-1423-4937-9137-099154E1C3EC",
    /** The EntityType Guid for Rock.Model.StepWorkflow  */
    StepWorkflow: "9E164DCB-2B3C-49DB-A3DA-E25E24BB23B9",
    /** The EntityType Guid for Rock.Model.StepWorkflowTrigger  */
    StepWorkflowTrigger: "55C1D610-D42F-4E08-9CD9-1EC9801BC4E3",
    /** The asset storage 'Amazon S3' component (Rock.Storage.AssetStorage.AmazonS3Component) */
    StorageAssetstorageAmazons3: "FFE9C4A0-7AB7-48CA-8938-EC73DEC134E8",
    /** The asset storage 'Azure Cloud Storage' component (Rock.Storage.AssetStorage.AzureCloudStorageComponent) */
    StorageAssetstorageAzurecloud: "1576800F-BFD2-4309-A2C9-AE6DF6C0A1A5",
    /** The asset storage file-system component (Rock.Storage.AssetStorage.FileSystemComponent) */
    StorageAssetstorageFilesystem: "FFEA94EA-D394-4C1A-A3AE-23E6C50F047A",
    /** The asset storage 'Google Cloud Storage' component (Rock.Storage.AssetStorage.GoogleCloudStorageComponent) */
    StorageAssetstorageGooglecloud: "71344FA8-4210-4B6C-ADC1-9F63C4CA15CA",
    /** The guid for the database storage provider entity */
    StorageProviderDatabase: "0AA42802-04FD-4AEC-B011-FEB127FC85CD",
    /** The guid for the file-system storage provider entity (Rock.Storage.Provider.FileSystem) */
    StorageProviderFilesystem: "A97B6002-454E-4890-B529-B99F8F2F376A",
    /** The guid for Rock.Model.Streak */
    Streak: "D953B0A5-0065-4624-8844-10010DE01E5C",
    /** The EntityType Guid for Rock.Achievement.Component.StreakAchievement  */
    StreakAchievementComponent: "174F0AFF-3A5E-4A20-AE8B-D8D83D43BACD",
    /** The EntityType Guid for Rock.Model.StreakType  */
    StreakType: "66203975-2A7A-4000-870E-76457DF3C920",
    /** The EntityType Guid for Rock.Model.StreakTypeExclusion  */
    StreakTypeExclusion: "1F00C782-F8A2-4CFA-B7DF-E5B3B6D36069",
    /** The guid for the system communication entity */
    SystemCommunication: "D0CAD7C0-10FE-41EF-B89D-E6F0D22456C4",
    /** The EntityType Guid for Rock.Model.SystemEmail  */
    SystemEmail: "B21FD119-893E-46C0-B42D-E4CDD5C8C49D",
    /** The EntityType Guid for Rock.Model.SystemPhoneNumber  */
    SystemPhoneNumber: "66D62A9F-13CD-4160-8653-211B2A4ABF16",
    /** The EntityType Guid for Tag. */
    Tag: "d34258d0-d366-4efb-aa76-84b059fb5434",
    /** The EntityType Guid for Rock.Model.TaggedItem  */
    TaggedItem: "AB97403A-206E-4E0C-AC42-856A010FA6DD",
    /** The EntityType Guid for Rock.Model.UserLogin  */
    UserLogin: "0FA592F1-728C-4885-BE38-60ED6C0D834F",
    /** The EntityType Guid for Rock.Model.WebFarmNode  */
    WebFarmNode: "2338D5C3-E808-408F-B000-E8A7D8A4858C",
    /** The EntityType Guid for Rock.Model.WebFarmNodeLog  */
    WebFarmNodeLog: "E00B4559-8E53-4B21-8B29-DB2E6DD74C50",
    /** The EntityType Guid for Rock.Model.WebFarmNodeMetric  */
    WebFarmNodeMetric: "3194A5E3-F352-4CD0-A585-F1DD37008B9C",
    /** The EntityType Guid for Rock.Model.Workflow */
    Workflow: "3540E9A7-FE30-43A9-8B0A-A372B63DFC93",
    /** The EntityType Guid for Rock.Model.WorkflowAction  */
    WorkflowAction: "9CBF4BEC-5653-47F9-8E87-0D31C6CA5947",
    /** The EntityType Guid for Rock.Model.WorkflowActionForm  */
    WorkflowActionForm: "FDAB9AEB-B2AA-4FB5-A35D-83254A9B014C",
    /** The EntityType Guid for Rock.Model.WorkflowActionFormAttribute  */
    WorkflowActionFormAttribute: "E147611F-D1AB-4C34-A1F8-84A118BAFDE3",
    /** The EntityType Guid for Rock.Model.WorkflowActionFormSection  */
    WorkflowActionFormSection: "90AF7254-87A2-42CB-B2F6-D4D53D7E30A0",
    /** The EntityType Guid for Rock.Model.WorkflowActionType */
    WorkflowActionType: "23E3273A-B137-48A3-9AFF-C8DC832DDCA6",
    /** The EntityType Guid for Rock.Model.WorkflowActivity */
    WorkflowActivity: "2CB52ED0-CB06-4D62-9E2C-73B60AFA4C9F",
    /** The EntityType Guid for Rock.Model.WorkflowActivityType  */
    WorkflowActivityType: "E5FBDBA2-9539-4679-B948-2E06C1BB1E3F",
    /** The EntityType Guid for Rock.Model.WorkflowFormBuilderTemplate. */
    WorkflowFormBuilderTemplate: "65fa3078-9d42-4857-b78a-f32a05f7a4c1",
    /** The EntityType Guid for Rock.Model.WorkflowLog */
    WorkflowLog: "332CFF36-D637-414D-B732-370B330B8D73",
    /** The EntityType Guid for Rock.Model.WorkflowTrigger  */
    WorkflowTrigger: "3781C82A-7F40-4D88-B3DB-1B9589D73D3D",
    /** The EntityType Guid for Rock.Model.WorkflowType */
    WorkflowType: "C9F3C4A5-1526-474D-803F-D6C7A45CBBAE",
};
